import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useTabIndicator } from "../../components/useTabIndicator";
import { isEmpty } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";

const GameMenu = ({ game, setGame, setSearch }) => {
  const setTab = useContextSelector(AuthContext, (ctx) => {
    return ctx.setTab;
  });
  const tab = useContextSelector(AuthContext, (ctx) => {
    return ctx.tab;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setParlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlay;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const location = useLocation();
  const navigate = useNavigate();
  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  const divRef = useRef(null);
  return (
    <>
      <section
        data-v-d714557a
        id="index-filter"
        className="flex relative z-10 text-global-font-on-dark bg-secondary"
        style={{
          "--65ebd787": `${indicatorStyle?.width || 48}px`,
          "--5aa87fa9": `translateX(${indicatorStyle?.x + divRef?.current?.offsetWidth
            }px)`,
        }}
      >
        <div
          ref={divRef}
          // onClick={() => {
          //   if (isEmpty(user)) {
          //     navigate("/login");
          //   } else {
          //     setParlay(!parlay);
          //     if (location?.pathname?.split("/")[1] == "favourite-velkie") {
          //       navigate("/sports-velki");
          //     }
          //   }
          // }}
          data-v-d714557a
          className="py-3 bg-black-900 flex justify-start items-center px-2 font-bold"
        >
          <div data-v-d714557a className="flex pt-px">
            <div data-v-3c7c6c93 data-v-d714557a className="btn-switch">
              <input
                data-v-3c7c6c93
                id="settingFilter"
                className="btn-switch__tgl btn-switch__tgl-ios"
                disabled
              />
              <label
                data-v-3c7c6c93
                className={`p-px rounded-2xl w-7 h-3.5 btn-switch__tgl-label-shadow-none ${parlay ? "btn-switch__tgl-label-shadow-none-active" : ""
                  }`}
              />
            </div>
          </div>
          <span
            data-v-d714557a
            className={`ml-2 text-15 text-black-600 leading-tight duration-300 ${parlay ? "text-filter-active" : ""
              }`}
          >
            Parlay
          </span>
        </div>
        <div
          ref={containerRef}
          data-v-d714557a
          className="flex w-full justify-evenly items-center"
        >
          {tabList?.map((res, index) => {
            return (
              <div
                onClick={() => {
                  if (location?.pathname?.split("/")[1] == "favourite-velkie") {
                    setTab(res?.key);
                    navigate("/sports-velki");
                  } else {
                    setActiveIndex(index);
                    setTab(res?.key);
                    navigate("/sports-velki");
                  }
                }}
                data-v-d714557a
                className={`text-15 whitespace-nowrap ${location?.pathname?.split("/")[1] == "favourite-velkie"
                    ? "opacity-75"
                    : tab == res?.key
                      ? "font-bold"
                      : "opacity-75"
                  } `}
              >
                {res?.label}
              </div>
            );
          })}
          <div
            data-v-d714557a
            onClick={() => {
              if (!parlay) {
                navigate("/favourite-velkie");
              }
            }}
            className={
              location?.pathname?.split("/")[1] == "favourite-velkie"
                ? "relative text-header-mypin-active icon-star-solid text-20"
                : parlay
                  ? "relative text-icon-light opacity-50 icon-star-disable text-22"
                  : "relative text-icon-light icon-star-solid text-20"
            }
          />
          <div onClick={() => setSearch(true)} data-v-d714557a>
            <span data-v-d714557a className="icon-search text-20" />
          </div>
        </div>
        {location?.pathname?.split("/")[1] != "favourite-velkie" && (
          <div
            data-v-d714557a
            className="tab-indicator absolute left-0 bottom-1 rounded-full bg-white"
          />
        )}
      </section>
      {location?.pathname?.split("/")[1] != "favourite-velkie" && (
        <section
          data-v-d714557a
          className="h-36px bg-submenu flex items-center"
        >
          <ul
            data-v-d714557a
            className="sport-type-filter-ul space-x-2 ml-8px flex flex-nowrap overflow-x-scroll"
          >
            {list?.map((res) => {
              return (
                <li
                  data-v-d714557a
                  onClick={() => setGame(res?.value)}
                  className={`h-30px w-80px justify-center flex items-center text-13 font-bold whitespace-nowrap event-type-tab  event-type-tab ${game == res?.value
                      ? "bg-filter-active active text-filter-active-icon"
                      : "text-global-font-on-dark"
                    }`}
                >
                  <i
                    data-v-d714557a
                    className={`mr-1 text-17 icon-${res?.value}`}
                  />
                  <span data-v-d714557a className="mt">
                    {res?.label}
                  </span>
                </li>
              );
            })}
          </ul>
        </section>
      )}
    </>
  );
};

const tabList = [
  {
    key: "in_play",
    label: "In-Play",
  },
  {
    key: "today",
    label: "Today",
  },
  {
    key: "active",
    label: "Tomorrow",
  },
];
const list = [
  { label: "All", value: "all" },
  { label: "Cricket", value: "cricket" },
  { label: "Soccer", value: "soccer" },
  { label: "Tennis", value: "tennis" },
];
export default GameMenu;
